import { combineReducers } from '@reduxjs/toolkit';
import actorCategoryReducer from './actor-mangement/actorCategorySlice';
import actorReducer from './actor-mangement/actorSlice';
import activityTypeReducer from './actor-mangement/acttivityTypeSlice';
import venueReducer from './actor-mangement/venueSlice';
import venueTypeReducer from './actor-mangement/venueTypeSlice';
import authReducer from './auth/authSlice';
import bookingReducer from './booking-management/bookingSlice';
import csiReducer from './csi/csiSlice';
import dashboardReducer from './dashboard/dashboardSlice';
import encounterAnalyticReducer from './encounter-management/encounterAnalyticSlice';
import encounterReducer from './encounter-management/encounterSlice';
import treatmentTypeReducer from './encounter-management/treatmentTypeSlice';
import healthCenterReducer from './health-center-management/healthCenterSlice';
import locationLevelReducer from './mdm/locationLevelSlice';
import locationReducer from './mdm/locationSlice';
import oheReducer from './ohe/oheSlice';
import patientReducer from './patient-management/patientSlice';
import encounterSettingsReducer from './settings/encounterSettingsSlice';
import fieldCustomizationReducer from './settings/fieldCustomizationSlice';
import formOptionReducer from './settings/formOptionSlice';
import generalSettingsReducer from './settings/generalSettingsSlice';
import tenantSettingsReducer from './settings/tenantSettingsSlice';
import roleReducer from './user/roleSlice';
import userReducer from './user/userSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  role: roleReducer,
  activityType: activityTypeReducer,
  actorCategory: actorCategoryReducer,
  actor: actorReducer,
  location: locationReducer,
  locationLevel: locationLevelReducer,
  venueType: venueTypeReducer,
  venue: venueReducer,
  patient: patientReducer,
  formOption: formOptionReducer,
  encounter: encounterReducer,
  treatmentType: treatmentTypeReducer,
  fieldCustomization: fieldCustomizationReducer,
  ohe: oheReducer,
  healthCenter: healthCenterReducer,
  csi: csiReducer,
  encounterSettings: encounterSettingsReducer,
  booking: bookingReducer,
  generalSettings: generalSettingsReducer,
  tenantSettings: tenantSettingsReducer,
  dashboard: dashboardReducer,
  encounterAnalytic: encounterAnalyticReducer
});

export default rootReducer;
